import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from "react";
import { Box, Image, Pressable, Text } from "native-base";
import { colors, commentDropItem, commentDropSlot } from "./useStyles";
export default function CommentDrop({ graphData = {}, commentState, setCommentState, setTooltip, setMoodGroup, timeData, setEvaluationBgHighlight, }) {
    const { limits, comments = [], randomIdFragment = "" } = graphData;
    const { timeStamps = [], timeCoords } = timeData;
    const memoComments = useMemo(() => {
        const groupedComments = Array.from({ length: timeStamps.length }, () => []);
        comments.forEach((comment) => {
            var _a;
            if (comment.msec) {
                const intervalIndex = timeCoords.findIndex(({ msec }) => comment.msec <= msec) -
                    1;
                (_a = groupedComments[intervalIndex]) === null || _a === void 0 ? void 0 : _a.push(comment);
            }
        });
        const mergedComments = groupedComments.map((group, groupIndex) => {
            if (group.length === 0)
                return null;
            return {
                comments: groupedComments[groupIndex],
                groupAvatarUrl: group.length === 1 ? group[0].user.avatarUrl : "",
                groupMonogram: group.length === 1
                    ? group[0].user.monogram
                    : `${group.length}`,
                hasDoctor: group.some(({ user }) => user.type === "doctor"),
                x: timeCoords[groupIndex].x,
            };
        });
        return {
            groupedComments,
            mergedComments,
        };
    }, [comments, timeCoords, timeStamps]);
    return (_jsx(_Fragment, { children: !!memoComments.mergedComments.length &&
            memoComments.mergedComments.map((group, i) => {
                const id = `${randomIdFragment}-comment-group-pos-${i}`;
                return group ? (_jsx(Box, Object.assign({ position: "absolute", zIndex: 2, style: {
                        left: group.x,
                        bottom: limits === null || limits === void 0 ? void 0 : limits.yMax,
                        transform: [
                            { translateY: 20 },
                            {
                                scale: commentState.onShow &&
                                    commentState.id === id
                                    ? 1.1
                                    : 1,
                            },
                        ],
                    } }, { children: _jsx(Pressable, Object.assign({ onPress: () => {
                            setCommentState((state) => (Object.assign(Object.assign({}, group), { id, onShow: state.id === id
                                    ? !state.onShow
                                    : true })));
                            setTooltip((state) => (Object.assign(Object.assign({}, state), { onShow: false })));
                            setEvaluationBgHighlight({
                                start: null,
                                end: null,
                                selected: -1,
                            });
                            setMoodGroup((state) => (Object.assign(Object.assign({}, state), { onShow: false })));
                        } }, { children: _jsx(Box, Object.assign({ nativeID: id, style: commentDropSlot, backgroundColor: group.hasDoctor
                                ? colors.grey800
                                : colors.green500 }, { children: group.groupAvatarUrl ? (_jsx(Image, { source: {
                                    uri: group.groupAvatarUrl,
                                }, style: commentDropItem, alt: "" })) : (_jsx(Box, Object.assign({ bg: group.hasDoctor
                                    ? "white"
                                    : "green.300", borderRadius: "full", alignItems: "center", justifyContent: "center" }, { children: _jsx(Text, Object.assign({ style: commentDropItem, color: group.hasDoctor
                                        ? "gray.800"
                                        : "white" }, { children: group.groupMonogram })) }))) }), id) })) }), id)) : (_jsx(Fragment, {}, id));
            }) }));
}
